package model

import kotlinx.serialization.Serializable

@Serializable
data class TokenAuthenticationResponse(
    val token: String
)